import { generateClient } from 'aws-amplify/api';

// Lazy client initialization to ensure Amplify is configured first
let client = null;
const getClient = () => {
  if (!client) {
    client = generateClient();
  }
  return client;
};

export const typingService = {
  async sendTypingStatus(conversationID, userID, isTyping) {
    try {
      await getClient().graphql({
        query: `
          mutation PublishTypingStatus($conversationID: ID!, $userID: ID!, $isTyping: Boolean!) {
            publishTypingStatus(conversationID: $conversationID, userID: $userID, isTyping: $isTyping) {
              conversationID
              userID
              isTyping
            }
          }
        `,
        variables: { conversationID, userID, isTyping },
      });
    } catch (error) {
      console.error('Error publishing typing status:', error);
    }
  },

  subscribeToTypingStatus: (conversationID, onTypingUpdate) => {
    const subscription = getClient().graphql({
      query: `
        subscription OnTypingStatusUpdated($conversationID: ID!) {
          onTypingStatusUpdated(conversationID: $conversationID) {
            conversationID
            userID
            isTyping
          }
        }
      `,
      variables: { conversationID },
    }).subscribe({
      next: ({ data }) => {
        if (data?.onTypingStatusUpdated) {
          onTypingUpdate(data.onTypingStatusUpdated);
        }
      },
      error: (err) => console.error('Typing status subscription error:', JSON.stringify(err, null, 2)),
    });

    return () => subscription.unsubscribe();
  },
};